"use client";
import {
  LayoutContext
} from "./chunk-FE37TETR.js";
import {
  useI18n
} from "./chunk-3P4ASMQP.js";
import {
  cn
} from "./chunk-S2JEC2ZU.js";
import "./chunk-6C3VEZWH.js";

// src/page.client.tsx
import { useEffect as useEffect2, useState as useState2 } from "react";

// src/components/toc.tsx
import { TextIcon } from "lucide-react";
import * as Primitive from "next-docs-zeta/toc";
import { useEffect, useRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
function TOCItems({ items }) {
  const { toc = "On this page" } = useI18n().text;
  const [pos, setPos] = useState();
  return /* @__PURE__ */ jsxs(
    Primitive.TOCProvider,
    {
      toc: items,
      className: "relative overflow-hidden pt-4 text-sm font-medium first:pt-0",
      children: [
        /* @__PURE__ */ jsxs("h3", { className: "mb-4 inline-flex items-center gap-2", children: [
          /* @__PURE__ */ jsx(TextIcon, { className: "h-4 w-4" }),
          toc
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1 border-l-2 text-muted-foreground", children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              role: "none",
              className: cn(
                "absolute left-0 border-l-2 transition-all",
                pos && "border-primary"
              ),
              style: {
                top: pos?.[0],
                height: pos?.[1]
              }
            }
          ),
          items.map((item) => /* @__PURE__ */ jsx(TOCItem2, { item, setMarker: setPos }, item.url))
        ] })
      ]
    }
  );
}
function TOCItem2({
  item,
  setMarker
}) {
  const active = Primitive.useActiveAnchor(item.url);
  const ref = useRef(null);
  useEffect(() => {
    if (active && ref.current) {
      setMarker([ref.current.offsetTop, ref.current.clientHeight]);
    }
  }, [active, setMarker]);
  return /* @__PURE__ */ jsx(
    Primitive.TOCItem,
    {
      ref,
      href: item.url,
      className: cn(
        "overflow-hidden text-ellipsis py-1 transition-colors data-[active=true]:text-primary",
        item.depth <= 2 && "pl-4",
        item.depth === 3 && "pl-7",
        item.depth >= 4 && "pl-10"
      ),
      children: item.title
    }
  );
}

// src/components/breadcrumb.tsx
import { ChevronRightIcon } from "lucide-react";
import { useBreadcrumb } from "next-docs-zeta/breadcrumb";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Fragment, useContext } from "react";
import { Fragment as Fragment2, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
function Breadcrumb() {
  const { tree } = useContext(LayoutContext);
  const pathname = usePathname();
  const items = useBreadcrumb(pathname, tree);
  if (items.length === 1)
    return /* @__PURE__ */ jsx2(Fragment2, {});
  return /* @__PURE__ */ jsx2("div", { className: "flex flex-row items-center gap-1 text-sm text-muted-foreground", children: items.map((item, i) => {
    const active = items.length === i + 1;
    const style = cn(
      "overflow-hidden whitespace-nowrap",
      active ? "text-foreground" : "text-ellipsis"
    );
    return (
      // eslint-disable-next-line react/no-array-index-key -- Won't re-render
      /* @__PURE__ */ jsxs2(Fragment, { children: [
        i !== 0 && /* @__PURE__ */ jsx2(ChevronRightIcon, { className: "h-4 w-4 shrink-0" }),
        item.url ? /* @__PURE__ */ jsx2(Link, { href: item.url, className: style, children: item.name }) : /* @__PURE__ */ jsx2("p", { className: style, children: item.name })
      ] }, i)
    );
  }) });
}

// src/page.client.tsx
import { jsxs as jsxs3 } from "react/jsx-runtime";
function LastUpdate(props) {
  const lastUpdate = useI18n().text.lastUpdate ?? "Last updated on";
  const [date, setDate] = useState2("");
  useEffect2(() => {
    setDate(props.date.toLocaleDateString());
  }, [props.date]);
  return /* @__PURE__ */ jsxs3("p", { className: "mt-8 text-xs text-muted-foreground", children: [
    lastUpdate,
    " ",
    date
  ] });
}
export {
  Breadcrumb,
  LastUpdate,
  TOCItems
};
